import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[numberOnly]',
  standalone: true,
})
export class NumberOnlyDirective {
  // Allow decimal numbers. The \. is only allowed once to occur
  private regex: RegExp = new RegExp(/^[0-9]+(\.[0-9]*){0,1}$/g);

  //control key state
  isCtrlPressed: boolean = false;

  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, home
  private specialKeys: Array<string> = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    'ArrowRight',
    'ArrowDown',
    'ArrowLeft',
    'ArrowUp',
    '.',
  ];

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: any) {
    this.isCtrlPressed = false;
    //prevent double decimal separator
    if (event.key === '.' && event.target.value.includes('.')) {
      event.preventDefault();
      return;
    }

    // Allow Backspace, tab, end, and home keys,
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    //allow and track ctrl, command and windows keys
    if (['Control', 'Meta'].includes(event.key)) {
      this.isCtrlPressed = true;
    }
    //allow ctrl actions/shortcuts (copy, paste, select all, cut,...)
    if (this.isCtrlPressed) {
      return;
    }

    //
    // if(event.key === ','){
    //     event.preventDefault();
    // }

    // Do not use event.keycode this is deprecated.
    // See: https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
    let current: string = this.el.nativeElement.value;
    // We need this because the current value on the DOM element
    // is not yet updated with the value from this event
    let next: string = current
      ? current?.concat(event.key).replace(/(,)/gi, '')
      : '';
    if (next && !String(next).match(this.regex)) {
      event?.preventDefault();
    }
  }
}
